import React from 'react';
import { Box, Typography, useMediaQuery } from '@mui/material';
import InstagramIcon from '@mui/icons-material/Instagram';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';

const Footer = () => {
  const isWideScreen = useMediaQuery('(min-width:800px)');

  const handleWhatsAppClick = () => {
    const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
    const whatsAppNumber = '573002081690';
    const message = 'Hola, estoy interesado en aprender BeachTennis!';

    if (isMobile) {
      window.open(`https://api.whatsapp.com/send?phone=${whatsAppNumber}&text=${encodeURIComponent(message)}`, '_blank');
    } else {
      window.open(`https://web.whatsapp.com/send?phone=${whatsAppNumber}&text=${encodeURIComponent(message)}`, '_blank');
    }
  };


  const handleInstagramClick = () => {
    window.open('https://www.instagram.com/beachtennismedellin/', '_blank');
  };

  return (
    <Box
      component="footer"
      sx={{
        backgroundColor: isWideScreen ? '#777777' : '#E1AD31',
        color: '#ffffff',
        padding: '1.5em 0',
        textAlign: 'center',
        marginTop: 'auto',
        height: '50px',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        boxShadow: '0px 4px 6px rgba(0, 0, 0, 0.1)',
        position: 'fixed', 
        bottom: 0,
        width: '100%'
      }}
    >
      <Typography variant="body1" sx={{ fontFamily: 'Roboto', color: 'black', fontSize:'1.5em'}}>
        &copy; {new Date().getFullYear()} Beach Tennis Medellín
      </Typography>
      <Box sx={{ marginTop: '0.5em' }}>
        <InstagramIcon onClick={handleInstagramClick} style={{ cursor: 'pointer', marginRight: '0.5em', fontSize: '2.5em' }} />
        <WhatsAppIcon onClick={handleWhatsAppClick} style={{ cursor: 'pointer', marginRight: '0.3em', fontSize: '2.5em' }} />
      </Box>
    </Box>
  );
};

export default Footer;
